module.exports = __webpack_public_path__ + "assets/img/11_482.5b1a2245.jpg";